import { useRef } from 'react';
import axios from 'axios';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import GlobalFilters from '../../../GlobalFilters/GlobalFilters';
import { THEME_CLASSES, themeColors } from '../constants/main-menu.constants';
import { updateTheme } from '../services/header.service';

const GlobalFilterContainer = () => {
  const toast = useRef<Toast | null>(null);
  const menuLeft = useRef<Menu>(null);
  document.body.classList.add(localStorage.getItem('theme') ?? 'light-blue');

  const items = themeColors?.map(item => ({
    label: item.label,
    template: () => (
      <div className="w-12 p-2">
        <div
          className={`${item?.value == localStorage.getItem('theme') && 'border-1 border-400 shadow-1 border-round-sm'}`}
        >
          <Button
            className="w-12 p-2 flex flex-column align-items-start"
            text
            onClick={async e => {
              menuLeft?.current?.hide(e);
              const response = await updateTheme(item.value);
              if (response?.themeData?.status === 200) {
                document.body.classList.remove(...THEME_CLASSES);
                document.body.classList.add(item.value);
                localStorage.setItem('theme', item.value ?? 'light-blue');
              } else {
                toast?.current?.show({
                  severity: 'error',
                  summary: response.error
                    ? response.message || 'Something went wrong.'
                    : 'Theme update failed.',
                });
              }
            }}
          >
            <div
              className="w-12 h-2rem border-round-xs"
              style={{
                background: item.color,
              }}
            />

            <div className="w-full mt-1 text-10 text-color text-center">
              {item.label}
            </div>
          </Button>
        </div>
      </div>
    ),
  }));
  return (
    <>
      <Toast ref={toast} />
      {axios.defaults.headers.common['client-id'] && (
        <div className="flex">
          <div className="lg:mr-1 xl:mr-2 align-items-stretch flex align-items-center md:shadow-1 md:bg-white border-round-xl xl:px-2">
            <GlobalFilters />
            <i
              className="pi pi-palette text-purple-600 text-md xl:ml-3 ml-2 mr-2 cursor-pointer py-2"
              onClick={e => menuLeft?.current?.toggle(e)}
            />
          </div>
        </div>
      )}
      <Menu
        model={items}
        popup
        ref={menuLeft}
        id="popup_menu_left"
        className="w-14"
        pt={{
          menu: { className: 'flex flex-wrap' },
          menuitem: { className: 'w-6' },
        }}
      />
    </>
  );
};

export default GlobalFilterContainer;
